import { useEffect, useState } from "react";
import LoadingSpinner from "../../../LoadingSpinner";
import { jobStatusHistory } from "../../../../api/jobApi";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineSeparator,
} from "@mui/lab";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import { HiOutlineStatusOnline } from "react-icons/hi";
import { formatFromJsonDate } from "../../../../dateConfig";

const VehicleStatusInfo = ({ requestId, jobId, activeTab }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const [activeAccordion1, setActiveAccordion1] = useState(true);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const statusData = await jobStatusHistory({ requestId, jobId });
      if (statusData) {
        setStatusData(
          statusData.map((sta) => ({
            ...sta,
            rstDate: sta.rstDate ? formatFromJsonDate(sta.rstDate) : "",
          }))
        );
      }
      setIsLoading(false);
    })();
  }, [jobId, requestId]);
  return (
    <div
      style={{
        overflowY: "auto",
        height: "66vh",
        display: activeTab === "status" ? "flex" : "none",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "1px",
      }}
      className="basic-info"
    >
      <div className="ui styled accordion" style={{ width: "100%" }}>
        <div
          className={`title ${activeAccordion1 ? "active" : ""}`}
          onClick={() => setActiveAccordion1(!activeAccordion1)}
        >
          <div>
            <span>Status</span>
            <HiOutlineStatusOnline size={14} style={{ marginLeft: "10px" }} />
            <i className="dropdown icon"></i>
          </div>
        </div>
        <div className={`content ${activeAccordion1 ? "active" : ""}`}>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <Timeline
              sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                  flex: 0,
                  padding: 0,
                },
              }}
              style={{
                margin: "0px",
                overflowY: "auto",
                overflowX: "hidden",
                padding: "0px",
              }}
            >
              {statusData &&
                statusData?.map((status, index) => (
                  <TimelineItem key={index}>
                    <TimelineSeparator>
                      <TimelineDot color={index === 0 ? "primary" : "grey"} />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <div className="timeline-container">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <h4
                            style={{
                              color: index === 0 ? "primary" : "grey",
                            }}
                          >
                            {status.rstDescription}
                          </h4>
                          <h5>{status.staRefCode}</h5>
                        </div>
                        <p>{status.rstUser}</p>
                        <p>{status.rstDate}</p>
                      </div>
                    </TimelineContent>
                  </TimelineItem>
                ))}
            </Timeline>
          )}
        </div>
      </div>
    </div>
  );
};

export default VehicleStatusInfo;
